export const TRANSACTION_STATUS = {
	BOOK: 'Suoritettu',
	CNCL: 'Peruutettu',
	SCHD: 'Odottaa',
} as const
